import { ComponentPropsWithoutRef, FC } from "react";
import { twMerge } from "tailwind-merge";

// TikTok's player iframe (developers.tiktok.com/doc/embed-player) in a 9:16
// box. TikTok's embed.js, which react-social-media-embed used, now keeps its
// "View post on TikTok" placeholder and adds the player below it.
type TikTokVideoProps = {
  videoId: string;
  title?: string;
} & ComponentPropsWithoutRef<"div">;

const TikTokVideo: FC<TikTokVideoProps> = ({
  videoId,
  title = "TikTok video",
  className,
  ...rest
}) => (
  <div
    {...rest}
    className={twMerge(
      "aspect-[9/16] w-full overflow-hidden rounded-xl bg-black",
      className,
    )}
  >
    <iframe
      // rel=0: no other creators' videos when it ends.
      src={`https://www.tiktok.com/player/v1/${videoId}?rel=0`}
      title={title}
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
      allowFullScreen
      className="h-full w-full border-0"
    />
  </div>
);

export default TikTokVideo;
